export const removeHtmlTagsFromString = (text: string): string => {
  try {
    return text.replaceAll(/<[^>]+>/g, "");
  } catch (error) {
    return text || "";
  }
};
